import { Controller } from "@hotwired/stimulus"

// Discord role selector controller for album forms
export default class extends Controller {
  static values = { 
    roles: Array 
  }

  connect() {
    this.updateRoleIndicator()
  }

  change(event) {
    this.updateRoleIndicator()
  }

  updateRoleIndicator() {
    const selectedRoleId = this.element.value
    
    if (!selectedRoleId) {
      this.clearRoleIndicator()
      return
    }

    const selectedRole = this.rolesValue.find(role => role.id === selectedRoleId)
    
    if (selectedRole) {
      this.showRoleIndicator(selectedRole)
    } else {
      this.clearRoleIndicator()
    }
  }

  showRoleIndicator(role) {
    // Remove existing indicator
    this.clearRoleIndicator()
    
    // Create role color indicator
    const indicator = document.createElement('div')
    indicator.className = 'discord-role-indicator inline-flex items-center gap-2 mt-2 px-3 py-2 bg-gray-50 rounded-lg border border-gray-200 text-sm'
    indicator.innerHTML = `
      <div class="w-3 h-3 rounded-full" style="background-color: ${role.color}"></div>
      <span class="font-medium text-gray-700">Rôle Discord: ${role.name}</span>
    `
    
    this.element.parentElement.appendChild(indicator)
  }

  clearRoleIndicator() {
    const existing = this.element.parentElement.querySelector('.discord-role-indicator')
    if (existing) {
      existing.remove()
    }
  }
}